import { BrowserCacheLocation, IPublicClientApplication, InteractionType, PublicClientApplication, LogLevel } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from './../../environments/environment';

/**
 * Logger callback function
 * @param _logLevel LogLevel
 * @param message The message
 */
export function loggerCallback(_logLevel: LogLevel, message: string) {
  !environment.production && console.log(message);
}

//https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/msal-angular-v2-samples/angular11-b2c-sample/src/app/b2c-config.ts
//https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/msal-angular-v2-samples/angular11-b2c-sample/src/app/app.module.ts

/**
 * Factory that creates and configures MSAL
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.AzureClientId,
      authority: environment.AzureAuthority,
      redirectUri: environment.AzureRedirectUri,
      postLogoutRedirectUri: environment.AzurePostLogoutRedirectUri,
      knownAuthorities: [environment.AzureAuthorityDomain]
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: environment.production ? LogLevel.Error : LogLevel.Trace,
        piiLoggingEnabled: false
      }
    }
  });
}

/**
 * Factory that configures the MSAL interceptor
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: environment.AzureProtectedResourceMap
  };
}

/**
 * Factory that configures the MSAL auth guard
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.AzureScopes
    }
  };
}
